export const Page404 = () => {
  return <h1 style={{ marginTop: 200, marginBottom: 200, textAlign: "center" }}>404</h1>;
};
